import { Delete, Edit } from '@mui/icons-material';
import { Alert, CardContent } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { updateUserProject } from '../../../modules/project';
import Modal from '../../elements/Modal';
import UserProjectForm from './UserProjectForm';
import DeleteProject from './DeleteProject';
import CustomIconButton from '../../elements/CustomIconButton';
import { useNotification } from '../../../hooks/NotificationContext';
import { useInvalidateQuery } from '../../../query/apiQueries';

const EditUserProject = ({ selectedProject, fetchProjectData }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const currentUserId = JSON.parse(localStorage.getItem('user')).id;
  const { addNotification } = useNotification();
  const initialValues = {
    name: selectedProject.name,
    description: selectedProject.description,
    reviewWorkflow: selectedProject.review_workflow,
    mandatoryAssignedTo: selectedProject.mandatory_assigned_to,
    defaultAssignedTo: selectedProject.default_assigned_to || currentUserId,
  };
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const invalidateQueries = useInvalidateQuery();

  const handleClickOpen = useCallback(() => {
    setError(null);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => setOpen(false), []);
  const handleSave = async (values) => {
    const project = {
      name: values.name,
      description: values.description,
      id: selectedProject.id,
      reviewWorkflow: values.reviewWorkflow,
      mandatoryAssignedTo: values.mandatoryAssignedTo,
      defaultAssignedTo: values.defaultAssignedTo,
    };
    try {
      await updateUserProject(project);
      addNotification('success', 'Project updated successfully!');
      fetchProjectData();
      handleClose();
      invalidateQueries([
      { key: 'project', type: 'headerProjects' },
      { key: 'project', type: 'dashboardProjects' },
      { key: 'project', type: 'list' },
    ]);
    } catch (error) {
      setError(error.message || 'Failed to update project. Please try again.');
    }
  };

  const handleDeleteButtonClick = () => {
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmationOpen(false);
  };

  return (
    <>
      <CustomIconButton
        title="Edit Project"
        disableRipple
        onClick={handleClickOpen}>
        <Edit />
      </CustomIconButton>
      <CustomIconButton
        title="Delete Project"
        disableRipple
        onClick={handleDeleteButtonClick}>
        <Delete sx={{color: 'red'}} />
      </CustomIconButton>
      <Modal
        open={open}
        width="md"
        modalTitle="Edit Project"
        handleClose={handleClose}>
        <CardContent sx={{ pt: 0 }}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <UserProjectForm
            initialValues={initialValues}
            onSubmit={handleSave}
            selectedProject={selectedProject}
            error={error}
            type="edit"
          />
        </CardContent>
      </Modal>
      <DeleteProject
        open={deleteConfirmationOpen}
        handleDeleteCancel={handleDeleteCancel}
        selectedProject={selectedProject}
        setDeleteConfirmationOpen={setDeleteConfirmationOpen}
        fetchProjectData={fetchProjectData}
      />
    </>
  );
};

export default EditUserProject;
